import React from 'react';
import { useMap } from 'react-map-gl';
import "./TopButtons.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '../../../common/ToolTip/ToolTip';
import { useTranslation } from 'react-i18next';

function popupwindow(url: string, w: number, h: number) {
    const left = (window.screen.width / 2) - (w / 2);
    const top = (window.screen.height / 2) - (h / 2);
    return window.open(url, 'popUpWindow', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}

export default function OpenGoogleMapsButton() {

    const { t } = useTranslation("nbhd");
    const map = useMap()
    const toggle = () => {

        if (!map.current) {
            return null;
        }

        const latLng = (map.current.getMap()).getCenter()
        let url = "http://maps.google.com/maps?q=";
        url += latLng["lat"].toString() + "," + latLng["lng"].toString();

        popupwindow(url, 1200, 600);
    }

    return (
        <button className={'mapboxgl-ctrl mapboxgl-ctrl-group sattlite-button first-button'} onClick={() => toggle()} aria-label="mapbox-global-view-btn" >
            <Tooltip content={t('nbhd.Map-Nav.google')} direction={'left'}><FontAwesomeIcon icon={faUpRightFromSquare} /></Tooltip>
        </button>
    )
}